jQuery(function($) {

  if ( $('.wp-block-zoom-image').length > 0 ) {
    $('.wp-block-zoom-image').each(function() {
      const panzoom = Panzoom( $(this).find('.panzoom')[0], {
        maxScale: 6
      });
      $(this).find('.zoomIn').on( 'click', panzoom.zoomIn );
      $(this).find('.zoomOut').on( 'click', panzoom.zoomOut );
      $(this).find('.reset').on( 'click', panzoom.reset );
    });
  }

});